export default {
  title_captain: {
    en: 'Captain',
    fr: 'Capitaine',
  },
  title_co_captain: {
    en: 'Co-Captain',
    fr: 'Co-Capitaine',
  },
  title_treasury: {
    en: 'Treasury',
    fr: 'Trésorerie',
  },
  title_project_manager: {
    en: 'Project Manager',
    fr: 'Responsable de Projet',
  },
  title_technical_director: {
    en: 'Technical Director',
    fr: 'Directeur Technique',
  },
  title_technical_director_f: {
    en: 'Technical Director',
    fr: 'Directrice Technique',
  },
  title_social_coordinator: {
    en: 'Social Coordiantor',
    fr: 'Coordinateur Social',
  },
  title_social_manager: {
    en: 'Social Manager',
    fr: 'Responsable du département de communication',
  },
  title_event_manager: {
    en: 'Event Manager',
    fr: 'Responsable Événementiel',
  },
  title_partnership_manager: {
    en: 'Partnership Manager',
    fr: 'Responsable Partenariat',
  },
  title_merchandise_manager: {
    en: 'Merchandise Manager',
    fr: 'Responsable Marchandise',
  },
  title_chef_technology: {
    en: 'Technology Manager',
    fr: 'Responsable du département Technologie',
  },
  title_chef_production: {
    en: 'Production Manager',
    fr: 'Responsable de la Production',
  },
  title_chef_communication: {
    en: 'Communication Manager',
    fr: 'Responsable du département Communication',
  },
  title_member: {
    en: 'Member',
    fr: 'Membre',
  },
  title_sponsor: {
    en: 'Sponsor',
    fr: 'Commanditaire',
  },
};
